/**
 * Client-side mirror of backend/utils/job_norm.py::normalize_description.
 * Used exclusively by the admin JobEditorDialog live preview so an admin can
 * see exactly how their description will render on the public page before
 * saving. The backend still runs its own normalization on write — this is
 * strictly a preview convenience, never authoritative.
 *
 * Keep this file in sync with the backend implementation if the behavior
 * ever changes.
 */
const TAG_STRIP = /<(script|style)[^>]*>[\s\S]*?<\/\1>/gi;
const INLINE_STYLE = /\s(style|class|onclick|onerror|onload)="[^"]*"/gi;
const MULTI_BLANK = /\n{3,}/g;
const BLOCK_TAG = /<\/?(p|ul|ol|li|h[1-6]|blockquote|br)\b/i;
const WS = /\s+/g;

export const normalizeDescription = (raw) => {
    if (!raw) return "";
    let text = String(raw).trim();
    text = text.replace(TAG_STRIP, "");
    text = text.replace(INLINE_STYLE, "");
    if (BLOCK_TAG.test(text)) {
        return text.replace(MULTI_BLANK, "\n\n").trim();
    }
    const blocks = text.split(/\n\s*\n/).map((b) => b.trim()).filter(Boolean);
    return blocks.map((b) => `<p>${b.replace(WS, " ")}</p>`).join("\n");
};
